import React, { useContext } from "react"
import { Outlet, Navigate } from "react-router-dom"
import { F_INDEX } from "../constants/routes"
import UserContext from "../context/UserContext"

const AuthenticatedArea = ({ role }) => {
  const { userData } = useContext(UserContext)

  const isUser = role === "User" && userData?.token && userData?.user

  const isSchool = role === "School" && userData?.token && userData?.school

  const isAdmin = role === "Admin" && userData?.token && userData?.admin

  if (role === "User" && !isUser) {
    return <Navigate to={F_INDEX} replace />
  }

  if (role === "School" && !isSchool) {
    return <Navigate to={F_INDEX} replace />
  }

  if (role === "Admin" && !isAdmin) {
    return <Navigate to={F_INDEX} replace />
  }

  return <Outlet />
}

export default AuthenticatedArea
